module.exports = __webpack_public_path__ + "media/images/emoticons/carouselpony-a227487b8bdbfe408017a5c44fae7f05.gif";